import React from 'react';

import Icon from 'Components/Base/Icon';
import CopyContactText from './CopyContactText';

const ContactDetailRow = ({ iconName, displayText, href }) => {
  return (
    <div className="phone_row">
      <Icon name={iconName} className="phone_icon" />
      <a className="phone_link phone_link--mobile" href={href}>
        {displayText}
      </a>
      <CopyContactText text={displayText} />
    </div>
  );
};

export default ContactDetailRow;
